import React from 'react';
import {OrderedListProps} from 'react-markdown/lib/ast-to-react';

import {list} from '../Markdown.css';

export const OrderedList = ({children}: React.PropsWithChildren<OrderedListProps>) => {
  return <ol className={list}>{children}</ol>;
};
